import type { Indicator, IndicatorDirection } from '../../../types/indicator';
import type { LstTemplate } from '../types';

export interface TemplateIndicatorLink {
  hasLink: boolean;
  name: string | null;
  target: number | null;
  direction: IndicatorDirection;
  globalId: string | null;
  unit: string;
}

export function templateHasLinkedIndicator(
  template: Pick<
    LstTemplate,
    'linked_indicator_id' | 'linked_indicator_name' | 'linked_indicator_target'
  >,
): boolean {
  if (template.linked_indicator_id) return true;
  const name = template.linked_indicator_name?.trim();
  const target = template.linked_indicator_target;
  return !!(name && target != null && target > 0);
}

export function resolveTemplateIndicator(
  template: Pick<
    LstTemplate,
    | 'linked_indicator_id'
    | 'linked_indicator_name'
    | 'linked_indicator_target'
    | 'linked_indicator_direction'
  >,
  indicators: Indicator[],
): TemplateIndicatorLink {
  const direction: IndicatorDirection = template.linked_indicator_direction ?? 'higher_is_better';

  if (template.linked_indicator_id) {
    const ind = indicators.find((i) => i.id === template.linked_indicator_id);
    const target = template.linked_indicator_target ?? ind?.target_value ?? null;
    return {
      hasLink: target != null && target > 0,
      name: ind?.name ?? 'Indicador global',
      target,
      direction: ind?.direction ?? direction,
      globalId: template.linked_indicator_id,
      unit: ind?.unit ?? '',
    };
  }

  const customName = template.linked_indicator_name?.trim();
  const customTarget = template.linked_indicator_target;
  if (customName && customTarget != null && customTarget > 0) {
    return {
      hasLink: true,
      name: customName,
      target: customTarget,
      direction,
      globalId: null,
      unit: '',
    };
  }

  return { hasLink: false, name: null, target: null, direction, globalId: null, unit: '' };
}

/** Rótulo para exibição (global ou custom). */
export function templateIndicatorLabel(
  template: Pick<LstTemplate, 'linked_indicator_id' | 'linked_indicator_name'>,
  indicators: Indicator[],
): string | null {
  if (template.linked_indicator_id) {
    return indicators.find((i) => i.id === template.linked_indicator_id)?.name ?? 'Indicador';
  }
  return template.linked_indicator_name?.trim() || null;
}

export function templatesWithIndicatorLink(templates: LstTemplate[]): LstTemplate[] {
  return templates.filter(templateHasLinkedIndicator);
}
